<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">帮助中心</li>
                <li class="active">联系客服</li>
            </ul>
        </div>
        <div class="orderdetails_table_content">
            <Table
                border
                ref="selection"
                :loading="tloading"
                :columns="thead"
                :data="infolist"></Table>
        </div>
        <!-- 分页 -->
        <div class="page_content">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
export default {
    data() {
        return {
            tloading: false, // 表格加载中
            thead: [ // 表格头部
                {
                    align: 'center',
                    title: '类型',
                    key: 'typename'
                },
                {
                    align: 'center',
                    title: '名称',
                    key: 'name'
                },
                {
                    align: 'center',
                    title: '号码',
                    key: 'number'
                },
                {
                    align: 'center',
                    title: '操作',
                    key: 'number',
                    render: (h, params) => {
                        if (params.row.type == 1) {
                            return h('a',
                                        {
                                            domProps: {
                                                href: 'tencent://message/?uin=' + params.row.number + '&Site=&Menu-=yes'
                                            },
                                            style: {
                                                fontSize: '14px',
                                                color: '#666'
                                            }
                                        },
                                        '立即交谈'
                                    )
                        }
                    }
                }
            ],
            infolist: [], // 表格列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            if (this.pagecurrent == 1 && !this.$store.state.openmall) {
                this.pagesize = 32
                this.pagesizeopts[0] = 32
            } else {
                this.pagesize = 30
                this.pagesizeopts[0] = 30
            }

            this.tloading = true
            this.http.post(api.contactservice,
                {
                    page: this.pagecurrent,
                    pagesize: this.pagesize
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.infolist = response.data.msg.datalist
                this.pagetotal = response.data.msg.pagecontent.num
                this.tloading = false
            })
            .catch(error => {
                console.log(error);
            })
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Help'
            } else {
                link = '/ContactService'
            }
            this.$router.push(link)
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/help/contactservice.vue